import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IEndCheckingErp } from '../interfaces/IEndCheckingErp';

export async function fetchEndCheckingErpListAll(): Promise<IEndCheckingErp[]> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/catalogs/erp-erknm-close-settings/all`, {
    method: 'GET',
    credentials: 'include',
  }).then(handleResponse);
}

export async function fetchEndCheckingErpList(): Promise<IEndCheckingErp[]> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/catalogs/erp-erknm-close-settings`, {
    method: 'GET',
    credentials: 'include',
  }).then(handleResponse);
}

export async function addEndCheckingErp(formData: IEndCheckingErp): Promise<void> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/catalogs/erp-erknm-close-settings`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  }).then(handleResponse);
}

export async function changeEndCheckingErp(formData: IEndCheckingErp): Promise<void> {
  return fetch(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/catalogs/erp-erknm-close-settings/${formData.id}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    },
  ).then(handleResponse);
}

export async function deleteEndCheckingErp(id: number): Promise<void> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/catalogs/erp-erknm-close-settings/${id}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export async function changeErpErknmClose(id: number): Promise<void> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/erknm-close`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
